<template>
	<div>
		<el-tabs>
			<el-tab-pane label="购买用户">
				筛选次卡
				<el-select v-model="query.id" placeholder="筛选次卡" class="se" clearable filterable size="small">
					<el-option v-for="item in cardList" :key="item.id" :value="item.id" :label="item.name"></el-option>
				</el-select>
				筛选门店
				<el-select v-model="query.storeId" class="se" clearable filterable size="small">
					<el-option-group label="营业门店" class="store">
						<el-option v-for="item in stores" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-option-group>
					<el-option-group label="结业门店">
						<el-option v-for="item in storesEnd" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-option-group>
					</el-option>
				</el-select>
				搜索用户
				<el-input v-model="query.telephone" size="small" class="se" clearable placeholder="请输入用户手机号"></el-input>
				<el-button @click="listUser()" type="primary">筛选</el-button>
				<el-table :data="userData" highlight-current-row
					:header-cell-style="{'text-align':'center','background-color':'#ebebeb','color':'#333333','font-size':'18px'}"
					:cell-style="{'text-align':'center','font-size':'16px'}" style="margin-top: 30px;">
					<el-table-column label="验证头像">
						<template slot-scope="scope">
							<el-image :src="scope.row.avatarUrl" @click="addImg(scope.row.avatarUrl)"
								:preview-src-list="imgBig" style="width: 50px;height: 50px;">
								<div slot="error" class="image-slot">
									<i class="el-icon-picture-outline" style="width: 50px;height: 50px;"></i>
								</div>
							</el-image>
							<!-- <el-avatar :size="60" :src="scope.row.avatarUrl" @error="errorHandler" >
								<img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" />
							</el-avatar> -->
						</template>
					</el-table-column>
					<el-table-column prop="nickName" label="用户名">
						<template slot-scope="scope">
							{{scope.row.nickName == null?'暂无':scope.row.nickName}}
						</template>
					</el-table-column>
					<el-table-column label="手机号">
						<template slot-scope="scope">
							{{scope.row.telphone ==null?'暂无':scope.row.telphone}}
						</template>
					</el-table-column>
					<el-table-column prop="storeName" label="所属门店"></el-table-column>
					<el-table-column label="使用次数" sortable>
						<template slot-scope="scope">
							{{scope.row.times ==null?'暂无':scope.row.times}}
						</template>
					</el-table-column>
					<el-table-column label="购买日期">
						<template slot-scope="scope">
							{{scope.row.updateTime | timeFilter}}
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="query.page" :page-sizes="[10, 20, 30, 50,100]" :page-size="10"
						layout="total,sizes, prev, pager, next, jumper" :total="query.total">
					</el-pagination>
				</div>
			</el-tab-pane>
			<el-tab-pane label="期限卡管理">
				<el-button type="primary" @click="detail()">新建期限卡</el-button>
				<el-table :data="cardList"
					:header-cell-style="{'text-align':'center','background-color':'#ebebeb','color':'#333333','font-size':'18px'}"
					:cell-style="{'text-align':'center','font-size':'16px'}">
					<el-table-column prop="name" label="卡名"></el-table-column>
					<el-table-column prop="storeList" label="可用门店">
						<template slot-scope="scope">
							{{scope.row.storeList}}
						</template>
					</el-table-column>
					<el-table-column prop="serviceList" label="包含内容">
					</el-table-column>
					<el-table-column prop="dueDate" label="有效期">
						<template slot-scope="scope">
							{{scope.row.expiredType == false?"领取"+scope.row.day+"天后到期":scope.row.dueDate}}
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="text" @click="detail(scope.row.id)">编辑</el-button>
							<!-- <el-button type="text" @click="open(scope.row);">购买用户</el-button> -->
							<!-- <el-button type="text" style="color: red;">删除</el-button> -->
						</template>
					</el-table-column>
				</el-table>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	let that;
	export default {
		data() {
			return {
				cardList: [],
				typeList: [],
				name: '',
				userData: [],
				query: {
					page: 1,
					size: 10,
					total: 0,
					id: '',
					telephone: '',
					storeId: '',
				},
				stores: [], //营业门店
				storesEnd: [], //全部门店
				imgBig: [],
			}
		},
		beforeCreate() {
			that = this;
		},
		mounted() {
			this.getList();
			this.listUser();
			this.getStores()
		},
		filters: {
			typeFilter(val) {
				var label = ''
				that.typeList.forEach(item => {
					if (item.value == val) {
						label = item.label
					}
				})
				return label
			},
			nu(val) {
				if (val == null || val == '' || val == 'null' || val == undefined) {
					return "暂无"
				} else {
					return val;
				}
			},
			timeFilter(val) {
				if (val == null || val == '' || val == 'null' || val == undefined) {
					return "暂无"
				} else {
					return val.slice(0, 19);
				}
			}
		},
		methods: {
			getList() {
				this.$http.get("dTimesCard/list").then(res => {
					this.cardList = res.body.data
				})
			},
			detail(id) {
				this.$router.push({
					path: "/timeCardDetail",
					query: {
						id: id
					}
				})
			},
			listUser() {
				var q = this.query
				var a = '?pageNum=' + parseInt(q.page - 1) + '&pageSize=' + q.size
				if (q.id != '') {
					a += '&id=' + q.id
				}
				if (q.storeId != '') {
					a += '&storeId=' + q.storeId
				}
				if (q.telephone != '') {
					a += '&telephone=' + q.telephone
				}
				this.$http.get("dUserTimesCard/list" + a).then(res => {
					this.userData = []
					res.body.data.forEach(item => {
						this.userData.push(JSON.parse(item.user))
					})
					this.query.total = res.body.total
				})
			},
			getStores() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType == 1) {
							this.storesEnd.push(ele) //结业门店
						} else {
							this.stores.push(ele) //营业门店
						}
					})
				})
			},
			addImg(url) {
				this.imgBig = []
				if (url != '') {
					this.imgBig.push(url)
				}
			},
			handleSizeChange(val) {
				this.query.size = val
				this.listUser()
			},
			handleCurrentChange(val) {
				this.query.page = val
				this.listUser()
			},
			errorHandler() { //头像加载失败处理
				return true
			}
		}
	}
</script>

<style>
	.flex {
		display: flex;
	}

	.image-slot {
		width: 50px;
		height: 50px;
	}

	.pagination {
		text-align: center;
		margin-top: 20px;
	}

	.se {
		width: 150px;
		margin-right: 30px;
	}

	.image-slot {
		width: 50px;
		height: 50px;
	}
</style>